var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect.quiet",value:({
    handler: _vm.onIntersect,
    options: {
      root: null,
      rootMargin: _vm.margin,
      threshold: _vm.threshold,
    },
  }),expression:"{\n    handler: onIntersect,\n    options: {\n      root: null,\n      rootMargin: margin,\n      threshold: threshold,\n    },\n  }",modifiers:{"quiet":true}}],staticClass:"mx-auto"},[_c('div',{staticClass:"text-center"},[(_vm.isIntersecting && _vm.scroll)?_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }